import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const PurchaseEngine = lazy(() => import('../components/amazon/purchase-engine/PurchaseEngine'));
const BookSourcing = lazy(() => import('../components/sourcing/BookSourcing'));
const PrintRunBuilder = lazy(() => import('../components/sourcing/PrintRunView'));
const PrintCostEstimator = lazy(() => import('../components/sourcing/PrintCostEstimator'));
const BsrScanner = lazy(() => import('../components/sourcing/BsrScanner'));

export const purchasingRoutes = (
  <>
    <Route path="/purchasing/sourcing" element={<BookSourcing />} />
    <Route path="/purchasing/carton-engine" element={<PurchaseEngine />} />
    <Route path="/purchasing/print-runs" element={<PrintRunBuilder />} />
    <Route path="/purchasing/print-costs" element={<PrintCostEstimator />} />
    <Route path="/purchasing/bsr-scanner" element={<BsrScanner />} />
    <Route path="/sourcing" element={<Navigate to="/purchasing/sourcing" replace />} />
    <Route path="/amazon/purchase-engine" element={<Navigate to="/purchasing/carton-engine" replace />} />
    <Route path="/print-run" element={<Navigate to="/order-management/orders?type=print_run" replace />} />
  </>
);
